// env vars
export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
};
export const FIREBASE_EMULATOR_URL = import.meta.env.VITE_FIREBASE_EMULATOR_URL;
export const REST_API_PATH = import.meta.env.VITE_REST_API_PATH;
export const SENTRY_STAGE = import.meta.env.VITE_SENTRY_STAGE;

// misc
export const IS_DEV = (REST_API_PATH ?? '').includes('localhost');

export const LOCAL_STORAGE_KEY = {
  THEME: 'vizitpro-theme',
};

export const MAX_INPUT_LENGTH = 1_000;
export const MIN_INPUT_LENGTH = 3;
export const DEBOUNCE_IN_MS = 500;

// Job attachments and business logos: uploaded via the presigned-upload
// endpoint (POST /businesses/{id}/uploads), then registered via the
// resource's own endpoint. Keep the cap modest — these are field photos +
// PDFs. Types must match the backend's `content_type` enum exactly — it
// does not accept `image/heic`.
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_ATTACHMENT_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'application/pdf',
];
export const ACCEPTED_LOGO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const MESSAGE = {
  charMax: (limit: number) =>
    `Must be at most ${limit.toLocaleString()} characters`,
  charMin: (limit: number) =>
    `Must be at least ${limit.toLocaleString()} characters`,
  ERROR: 'Something went wrong, please try again',
  REQUIRED_FIELD: 'This field is required',
};
